function sleep(ms) {
    return new Promise(resolve => setTimeout(() => resolve(true), ms));
}
export { sleep };
export default sleep;
